import { awsAccountActions } from "../../modules/first-run/constants/awsAccounts";
import { orgHierarchyMock } from "../mockData/org-hierarchy-data";

function findElementById(data, id, type = "") {
  for (const item of data) {
    if (item.Id === id) {
      if (type === awsAccountActions.MOVE) {
        const delIdx = data.findIndex(({ Id }) => Id === id);
        data.splice(delIdx, 1);
      }
      return item;
    }
    if (item.Children) {
      const found = findElementById(item.Children, id, type);
      if (found) return found;
    }
  }
  return null;
}

export const updateOrgHierarchyData = (newAccount, ouid) => {
  const targetObj = findElementById(orgHierarchyMock, ouid);
  targetObj.Children.push(newAccount);
};

export const moveAccountToOU = (accountId, targetOUId) => {
  const account = findElementById(
    orgHierarchyMock,
    accountId,
    awsAccountActions.MOVE
  );
  updateOrgHierarchyData(account, targetOUId);
};
